<template>
  <div class="historyDetail">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div
      :class="historyDetail.visitorStatus"
      class="visitStatusBox"
    >{{ historyDetail.visitorStatus | formatStatus }}</div>
    <div v-if="historyDetail.visitorStatus === 'WAITING_VERIFY'" class="content">
      <div>
        <div class="content-title">验证信息</div>
        <div style="background: #fff">
          <div class="content-reason">
            <div class="content-reasonItem">
              <div>验证类型</div>
              <div>{{ historyDetail.beInvite ? '邀约验证' : '身份验证' }}</div>
            </div>
            <div class="content-reasonItem">
              <div>验证码</div>
              <div>{{ historyDetail.beInvite ? historyDetail.askCode : historyDetail.phone }}</div>
            </div>
          </div>
          <div class="tips">
            <p>温馨提示：</p>
            <p>1、来访当天请先到前台/自助机出示身份证验证通过后即可获得通行凭证；</p>
            <p v-if="historyDetail.remark">2、{{ historyDetail.remark }}</p>
            <p v-if="historyDetail.description">{{ historyDetail.remark ? '3' : '2' }}、{{ historyDetail.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="historyDetail.visitorStatus === 'WAITING_VISIT' || historyDetail.visitorStatus === 'VISITING'">
        <p class="content-title">凭证信息</p>
        <div style="background: #fff">
          <div class="content-reason">
            <p class="content-reasonItem">
              <span>通行方式</span>
              <span>{{ authTypes }}</span>
            </p>
          </div>
          <div v-if="historyDetail.qrCode" class="imageArea">
            <img :src="qrCodeImgUrl" alt="" style="width: 65%; object-fit: cover;">
          </div>
          <div v-if="historyDetail.qrCode" class="btns">
            <van-button icon="replay" type="info" @click="refreshQrcode">刷新</van-button>
          </div>
          <div v-if="historyDetail.qrCode" class="tips">
            <p>温馨提示：</p>
            <p>1、动态二维码仅限个人使用，3分钟有效，超时后刷新即可使用</p>
            <p v-if="historyDetail.remark">2、{{ historyDetail.remark }}</p>
            <p v-if="historyDetail.description">{{ historyDetail.remark ? '3' : '2' }}、{{ historyDetail.description }}</p>
          </div>
          <div v-else-if="historyDetail.remark" class="tips">
            <p>温馨提示：</p>
            <p>1、{{ historyDetail.remark }}</p>
            <p v-if="historyDetail.description">2、{{ historyDetail.description }}</p>
          </div>
        </div>
      </div>
      <p class="content-title">被访人信息</p>
      <div class="content-detail">
        <p>{{ historyDetail.beVisitStaffName }}</p>
        <p>公司：{{ historyDetail.beVisitCompanyName }}</p>
        <p>大厦：{{ historyDetail.beVisitEdificeName }}</p>
        <p>楼层：{{ historyDetail.beVisitFloorName }}</p>
      </div>
      <div class="content">
        <p class="content-title">来访事由和时间</p>
        <div class="content-reason">
          <p class="content-reasonItem">
            <span>来访事由</span>
            <span>{{ historyDetail.reason }}</span>
          </p>
          <p class="content-reasonItem">
            <span>来访时间</span>
            <span>{{ historyDetail.visitDate }}</span>
          </p>
          <p class="content-reasonItem">
            <span>离访时间</span>
            <span>{{ historyDetail.endVisitDate }}</span>
          </p>
          <p v-for="item in extraFields" :key="item.id" class="content-reasonItem">
            <span>{{ item.displayName }}</span>
            <span>{{ historyDetail[item.fieldName] || '无' }}</span>
          </p>
        </div>
      </div>
      <div class="content">
        <p class="content-title">来访动态</p>
        <van-steps direction="vertical" :active="historyDetail.statusLogs ? historyDetail.statusLogs.length - 1 : 0">
          <van-step v-for="son in historyDetail.statusLogs">
            <div>{{ son.statusInfo }}</div>
            <p>{{ son.createTime }}</p>
          </van-step>
        </van-steps>
      </div>
      <div v-if="historyDetail.remark" class="stall_tip">{{ `温馨提示：${historyDetail.remark}` }}</div>
      <van-button
        v-show="(historyDetail.visitorStatus === 'CANCEL' || historyDetail.visitorStatus === 'FINISH' || historyDetail.visitorStatus === 'UNVISIT' || historyDetail.visitorStatus === 'AUDIT_FAIL') && (historyDetail.visitorStatus!=='VISITING')"
        :disabled="false"
        class="sub_btn"
        type="info"
        @click="reappoint"
      >重新预约</van-button>
      <!-- 待审核，待验证，待到访 -->
      <van-button
        v-show="historyDetail.visitorStatus === 'WAITING_AUDIT' || historyDetail.visitorStatus === 'WAITING_VERIFY' || historyDetail.visitorStatus === 'WAITING_VISIT'"
        :disabled="false"
        class="sub_btn"
        type="info"
        @click="cancelAppointment"
      >取消预约</van-button>
      <!-- 访问中，超时逗留 -->
      <van-button
        v-show="historyDetail.visitorStatus == 'VISITING' || historyDetail.visitorStatus === 'OUTTIME_VISIT'"
        :disabled="false"
        class="sub_btn"
        type="info"
        @click="endVisit"
      >结束访问</van-button>
      <van-dialog
        v-model="showCancleDialog"
        title="温馨提示"
        show-cancel-button
        @confirm="confirmCancel"
      >
        <van-cell-group>
          <van-field v-model="message" class="control" rows="1" autosize type="textarea" placeholder="请输入取消原因" />
        </van-cell-group>
      </van-dialog>

      <van-dialog v-model="showEndDialog" title="温馨提示" show-cancel-button @confirm="confirmEnd">
        <van-cell-group style="padding: 0.24rem; line-height: 0.24rem;font-size: 0.13rem;">结束访问将认为您已离开并注销通行权限，是否确认结束访问？</van-cell-group>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { GetStaffAppointDetail, GetVisitorAppoinDetail, cancelAppointment } from '@/api/user';
import { Step, Steps } from 'vant';
import config from '@/common/config';
import { getReasons } from '@/api/home';
export default {
  name: 'HistoryDetail',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  filters: {
    // 过滤访客状态
    formatStatus(val) {
      const statusMap = {
        CANCEL: '已取消',
        WAITING_AUDIT: '待审核',
        WAITING_VERIFY: '待验证',
        AUDIT_FAIL: '未过审',
        WAITING_VISIT: '待到访',
        VISITING: '访问中',
        FINISH: '已完成',
        UNVISIT: '过期未到访',
        OUTTIME_VISIT: '超时逗留',
        AUDIT_PASSED: '已通过',
        AUDIT_REFUSED: '已拒绝',
        OUTTIME_AUDIT: '超时未审核'
      };
      return statusMap[val];
    }
  },
  data() {
    return {
      baseURL:
          process.env.NODE_ENV === 'development'
            ? config.baseUrl.dev
            : config.baseUrl.pro,
      subHead: '详情',
      visitStatus: '访问中',
      showCancleDialog: false,
      message: '',
      qrCodeImgUrl: '',
      historyDetail: {},
      showEndDialog: false,
      fromPage: '',
      authTypes: '',
      extraFields: [],
      statusMap: {
        FACE: '人脸识别',
        IC: ' IC卡',
        QR: '二维码',
        '': '无'
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPage = from.name;
    });
  },
  created() {
    this.getHistoryDetail();
  },
  methods: {
    goBack() {
      if (this.fromPage === 'staffMeetingHistoryDetail') {
        this.$router.push({ path: `staffMeetingHistoryDetail/${this.$route.query.backId}` }); // 用query传参不显示？
      } else {
        // this.$router.go(-1)
        // 从消息模板直接进到详情
        if (this.$route.query.type === 'staff') {
          this.$router.push({ name: 'staffHistory' });
        } else if (this.$route.query.type === 'visitor') {
          this.$router.push({ name: 'history' });
        } else {
          // 从历史记录进到详情
          this.personalInfo = JSON.parse(
            localStorage.getItem('personalInfo') || '{}'
          );
          switch (this.personalInfo.staff) {
            case false:
              this.$router.push({ name: 'history' });
              break;
            case true:
              this.$router.push({ name: 'staffHistory' });
              break;
            default:
              break;
          }
          // this.$router.push({ name: 'staffHistory' });
        }
        // else if (this.$route.path === '/historyDetail') {
        //   //从消息模板进到历史记录再进到详情
        //   this.$router.push({ name: 'history' })
        // } else if (this.$route.path === '/staffHistoryDetail') {
        //   this.$router.push({ name: 'staffHistory' })
        // }
      }
    },
    getHistoryDetail() {
      // 如果从员工消息模板或员工预约历史记录过来，员工预约详情
      if (this.$route.query.type === 'staff' || this.$route.query.activeName) {
        this.getStaffAppointDetail(this.$route.query.id);
      } else {
        // 从访客消息模板过来或方可历史记录过来，访客预约详情
        this.getVisitorAppoinDetail(this.$route.query.id);
      }
    },
    // 员工预约记录详情
    getStaffAppointDetail(id) {
      const data = {
        id: id
      };
      GetStaffAppointDetail(data).then(response => {
        this.historyDetail = response.data;
        // this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3);
        this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(response.data.qrCode)}&timestamp=${new Date().getTime()}`;
        let auth = '';
        response.data.authTypes && response.data.authTypes.forEach((item, index) => {
          if (index === response.data.authTypes.length - 1) {
            auth += this.statusMap[item];
          } else {
            auth += `${this.statusMap[item]}、`;
          }
        });
        this.authTypes = auth;
        getReasons({}).then(res => {
          // 假设 res.data.extraFields 可能存在也可能不存在，且其内部的 ASK 和 APPOINTMENT 也可能不存在
          const askArray = res.data.extraFields.ASK ? res.data.extraFields.ASK : [];
          const appointmentArray = res.data.extraFields.APPOINTMENT ? res.data.extraFields.APPOINTMENT : [];

          // 将两个数组合并为一个新数组，然后创建一个新的 Set
          this.extraFields = new Set(response.beInvite ? [...askArray] : [...appointmentArray]);
        });
      });
    },
    // 访客预约记录详情
    getVisitorAppoinDetail(id) {
      const data = {
        id: id
      };
      GetVisitorAppoinDetail(data).then(response => {
        this.historyDetail = response.data;
        // this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3);
        this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(response.data.qrCode)}&timestamp=${new Date().getTime()}`;
        let auth = '';
        response.data.authTypes && response.data.authTypes.forEach((item, index) => {
          if (index === response.data.authTypes.length - 1) {
            auth += this.statusMap[item];
          } else {
            auth += `${this.statusMap[item]}、`;
          }
        });
        this.authTypes = auth;
        getReasons({}).then(res => {
          // 假设 res.data.extraFields 可能存在也可能不存在，且其内部的 ASK 和 APPOINTMENT 也可能不存在
          const askArray = res.data.extraFields.ASK ? res.data.extraFields.ASK : [];
          const appointmentArray = res.data.extraFields.APPOINTMENT ? res.data.extraFields.APPOINTMENT : [];

          // 将两个数组合并为一个新数组，然后创建一个新的 Set
          this.extraFields = new Set(response.beInvite ? [...askArray] : [...appointmentArray]);
        });
      });
    },
    // 取消预约
    cancelAppointment() {
      this.showCancleDialog = true;
    },
    // 提交取消预约
    confirmCancel() {
      const data = {
        id: this.historyDetail.id,
        reason: this.message,
        status: 'CANCEL'
      };
      cancelAppointment(data).then(response => {
        this.showCancleDialog = false;
        if (response.code === 200) {
          this.getHistoryDetail();
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    // 重新预约
    reappoint() {
      sessionStorage.setItem('appointmentInfo', JSON.stringify(this.historyDetail));

      this.$router.push({ name: 'home', params: { id: this.historyDetail.id }});
    },
    // 结束访问
    endVisit() {
      this.showEndDialog = true;
    },
    // 提交结束访问
    confirmEnd() {
      const data = {
        id: this.historyDetail.id,
        reason: '',
        status: 'CANCEL'
      };
      cancelAppointment(data).then(response => {
        this.showEndDialog = false;
        if (response.code === 200) {
          this.getHistoryDetail();
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    refreshQrcode() {
      this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.historyDetail.qrCode)}&timestamp=${new Date().getTime()}`;
    }

  }
};
</script>

<style lang="less">
.historyDetail {
  padding-bottom: 0.1rem;
  .content {
    //  padding: 0rem 0.15rem;
    .content-title,
    .visitStatus {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
    }
    .content-detail,
    .content-reason {
      font-size: 0.17rem;
      color: #333;
      background: #fff;
      padding: 0.18rem 0.15rem;
    }
    .content-detail p:not(:last-child) {
      margin-bottom: 0.1rem;
    }
    .content-reason {
      padding: 0rem 0.15rem;
      .content-reasonItem {
        display: flex;
        justify-content: space-between;
        height: 0.55rem;
        line-height: 0.55rem;
        border-bottom: 1px solid #e5e5e5;
      }
      .content-reasonItem:not(:last-child) {
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .sub_btn {
    }
    .CANCEL,
    .OUTTIME_AUDIT {
      color: rgba(51, 51, 51, 0.5);
    }
    .WAITING_AUDIT,
    .WAITING_VERIFY {
      color: #f2b230;
    }
    .OUTTIME_VISIT {
      color: #f76260;
    }
    .FINISH {
      color: #3b86ff;
    }

    .btns {
      display: flex;
      justify-content: center;
      .van-button {
        display: flex;
        width: 0.85rem;
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        margin: 0.15rem auto;
      }
    }

    .tips {
      display: flex;
      flex-direction: column;
      font-size: 0.12rem;
      color: #ffbe00;
      line-height: 0.24rem;
      margin-left: 30px;
      padding-bottom: 30px;
    }
  }
  .control {
    .van-field__control{
      text-align: left !important;
    }
  }
}
.content-detail:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 1);
}

.stall_tip{
  padding: 0 0.15rem;
  font-size: 0.14rem;
  color: #888;
  margin-top: 0.1rem;
}

.imageArea {
  padding: 20px;
  text-align: center;
}
</style>
